/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComputedCommunicationPreference } from './ComputedCommunicationPreference';
import {
    ComputedCommunicationPreferenceFromJSON,
    ComputedCommunicationPreferenceFromJSONTyped,
    ComputedCommunicationPreferenceToJSON,
    ComputedCommunicationPreferenceToJSONTyped,
} from './ComputedCommunicationPreference';

/**
 * 
 * @export
 * @interface ComputedCommunicationPreferences
 */
export interface ComputedCommunicationPreferences {
    /**
     * 
     * @type {ComputedCommunicationPreference}
     * @memberof ComputedCommunicationPreferences
     */
    smsChat?: ComputedCommunicationPreference;
    /**
     * 
     * @type {ComputedCommunicationPreference}
     * @memberof ComputedCommunicationPreferences
     */
    googleEmailContactsExtraction?: ComputedCommunicationPreference;
    /**
     * 
     * @type {ComputedCommunicationPreference}
     * @memberof ComputedCommunicationPreferences
     */
    onboardingFlow?: ComputedCommunicationPreference;
}

/**
 * Check if a given object implements the ComputedCommunicationPreferences interface.
 */
export function instanceOfComputedCommunicationPreferences(value: object): value is ComputedCommunicationPreferences {
    return true;
}

export function ComputedCommunicationPreferencesFromJSON(json: any): ComputedCommunicationPreferences {
    return ComputedCommunicationPreferencesFromJSONTyped(json, false);
}

export function ComputedCommunicationPreferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComputedCommunicationPreferences {
    if (json == null) {
        return json;
    }
    return {
        
        'smsChat': json['smsChat'] == null ? undefined : ComputedCommunicationPreferenceFromJSON(json['smsChat']),
        'googleEmailContactsExtraction': json['googleEmailContactsExtraction'] == null ? undefined : ComputedCommunicationPreferenceFromJSON(json['googleEmailContactsExtraction']),
        'onboardingFlow': json['onboardingFlow'] == null ? undefined : ComputedCommunicationPreferenceFromJSON(json['onboardingFlow']),
    };
}

export function ComputedCommunicationPreferencesToJSON(json: any): ComputedCommunicationPreferences {
    return ComputedCommunicationPreferencesToJSONTyped(json, false);
}

export function ComputedCommunicationPreferencesToJSONTyped(value?: ComputedCommunicationPreferences | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'smsChat': ComputedCommunicationPreferenceToJSON(value['smsChat']),
        'googleEmailContactsExtraction': ComputedCommunicationPreferenceToJSON(value['googleEmailContactsExtraction']),
        'onboardingFlow': ComputedCommunicationPreferenceToJSON(value['onboardingFlow']),
    };
}

